module.exports = __webpack_public_path__ + "img/Interviewerr White.d34ecc48.png";